<!-- 从服务中心进行实名认证，成功后的结果页 -->
<template>
  <div class='verified'>
    <div class="shadow-top-box">
      <p class="font12">姓名</p>
      <input name="姓名" disabled type="text" placeholder="请输入姓名" v-model="name">
      <p class="font12">手机号</p>
      <input name="手机号" disabled type="tel" maxlength="11" placeholder="请输入手机号" v-model="phone">
      <p class="font12">身份证号码</p>
      <input name="身份证号" disabled type="text" placeholder="请输入身份证号" v-model="idNo">
    </div>
    <div class="flex justify-content-center"><input type="button" value="完成" class="lg-btn" @click="complete"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { UpdateRegisterInfo } from '@/api';
import { tuominMobile, tuominName, tuominIdCard } from "@/utils/verifyFunc";

export default {
  name: 'VerifiedResult',

  components: {},

  data () {
    return {
    };
  },

  computed: {
    ...mapState(['userInfo', 'OCRData']),
    phone() {
      let str = this.userInfo.phoneNo || localStorage.phone
      return tuominMobile(str)
    },
    name() {
      let str = this.userInfo.name
      return tuominName(str)
    },
    idNo() {
      let str = this.userInfo.idNo
      return tuominIdCard(str)
    }
  },

  created() {},

  methods: {
    complete() {
      // let { idNo, phoneNo, name, updateType, expIDDate } = this.userInfo;
      // UpdateRegisterInfo({ idNo, phoneNo, name, updateType:1, expIDDate: this.OCRData.validDate.split('-')[1] }).then(res => {
      this.$router.replace("/")//回到服务中心
      // }).catch(err => {
      //   this.$toast(err.data.resMessage)
      // })
    }
  },
}

</script>

<style lang='less' scoped>
  .verified {
    padding-top: 20px;
  }
  .shadow-top-box {
    padding: 30px 20px;
  }
  .font12 {
    padding-bottom: 10px;
  }
  input[type='text']{
    width: 100%;
    padding: 11px 0;
    border-bottom: 1px solid #ECECEC;
    margin-bottom: 20px;
  }
  input[type='tel']{
    width: 100%;
    padding: 11px 0;
    border-bottom: 1px solid #ECECEC;
    margin-bottom: 20px;
  }
</style>